import React from 'react';
import PropTypes from 'prop-types';
import StyleButton from "./StyleButton";
var INLINE_STYLES = [{
  label: 'B',
  style: 'BOLD'
}, {
  label: 'I',
  style: 'ITALIC'
}, {
  label: 'U',
  style: 'UNDERLINE'
}];
var InlineStyleControls = function InlineStyleControls(props) {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return /*#__PURE__*/React.createElement("div", {
    className: "RichEditor-controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-group",
    role: "group"
  }, INLINE_STYLES.map(function (type) {
    return /*#__PURE__*/React.createElement(StyleButton, {
      key: type.style,
      active: currentStyle.has(type.style),
      label: type.label,
      onToggle: props.onToggle,
      style: type.style
    });
  })));
};
InlineStyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired
};
export default InlineStyleControls;